var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 44,
    viewBox: "0 0 34 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 16.5H28V11C28 4.9335 23.0665 0 17 0C10.9335 0 6 4.9335 6 11V16.5H4.625C2.35167 16.5 0.5 18.3498 0.5 20.625V39.875C0.5 42.1502 2.35167 44 4.625 44H29.375C31.6483 44 33.5 42.1502 33.5 39.875V20.625C33.5 18.3498 31.6483 16.5 29.375 16.5ZM9.66667 11C9.66667 6.95567 12.9557 3.66667 17 3.66667C21.0443 3.66667 24.3333 6.95567 24.3333 11V16.5H9.66667V11ZM18.8333 30.657V34.8333C18.8333 35.8453 18.0138 36.6667 17 36.6667C15.9862 36.6667 15.1667 35.8453 15.1667 34.8333V30.657C14.0758 30.0208 13.3333 28.8512 13.3333 27.5C13.3333 25.4778 14.9778 23.8333 17 23.8333C19.0222 23.8333 20.6667 25.4778 20.6667 27.5C20.6667 28.8512 19.9242 30.0208 18.8333 30.657Z",
    fill: "#ED2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.fe5b8fd6c1850992f1fd457a704553ec.svg";
export { ForwardRef as ReactComponent };